import { Component, Input } from '@angular/core';

@Component({
  selector: 'rt-icon-rocket-02',
  standalone: true,
  templateUrl: './rt-icon-rocket-02.component.html',
  styleUrls: ['./rt-icon-rocket-02.component.scss']
})
export class RtIconRocket02Component {
  @Input() width: number | string = 22;
  @Input() height: number | string = 22;
}
